import { EIntakeStep } from "@rentiohq/shared-frontend/dist/types/application.types";
import { EIntakeType } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { getStepsForIntakeType } from "utils/application.utils";
import { EPropertyApplicationsCustom } from "./PropertyDetailApplications.types";

export const getSteps = (intakeType: EIntakeType) => {
  return getStepsForIntakeType(intakeType).reduce(
    (allSteps, steps: EIntakeStep[]) => {
      const eligibleSteps = steps.filter(
        step => step !== EIntakeStep.notEligible,
      );
      return [...allSteps, eligibleSteps];
    },
    [] as EIntakeStep[][],
  );
};

export const mappedApplications = {
  [EIntakeStep.candidateVisitor]: EPropertyApplicationsCustom.CandidateVisitors,
  [EIntakeStep.candidateTenant]: EPropertyApplicationsCustom.CandidateTenants,
  [EIntakeStep.tenant]: EPropertyApplicationsCustom.Tenant,
  [EIntakeStep.notEligible]: EPropertyApplicationsCustom.NotEligible,
  [EIntakeStep.visitor]: EPropertyApplicationsCustom.Visitors,
  [EIntakeStep.planAsVisitor]: EPropertyApplicationsCustom.ScheduleForVisit,
  [EIntakeStep.waitingList]: EPropertyApplicationsCustom.WaitingList,
};

export const getApplicationsFilterOptions = (intakeType: EIntakeType = 2) => {
  const steps = getSteps(intakeType);
  const flatStepsList = [...new Set((steps || []).flat())];
  return [
    EPropertyApplicationsCustom.All,
    EPropertyApplicationsCustom.WithApplications,
    ...flatStepsList.map(step => mappedApplications[step]),
    EPropertyApplicationsCustom.Archived,
    EPropertyApplicationsCustom.NotEligible,
  ];
};
